import { BaseHook } from './base.hook';

/* eslint-disable */
export class JointHook extends BaseHook {
  static register(hooks) {
    const hookList = this._getAllHooks(hooks);
    for(let hook of hookList) {
      hook.push(this.execute);
    }
  }

  static _getHooksSafe(hooks) {
    hooks[this.path] = hooks[this.path] || [];
    return hooks[this.path];
  }

  static _getAllHooks(hooks) {
    const hookList = [];
    for(let path of this.paths) {
      hooks[path] = hooks[path] || [];
      hookList.push(hooks[path]);
    }
    return hookList;
  }
}
